// extracted by mini-css-extract-plugin
export default {"bannerContainer":"_9nby9m"};